import type { SVGProps } from 'react';

const SvgFullscreenExitLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M4 16H8V20' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M20 8H16L16 4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M16 20L16 16H20' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8 4V8H4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgFullscreenExitLt;
